import type { IconData } from '@stacksjs/iconify-core'

export const bj1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGwQJ26ddR\"><path fill=\"gray\" d=\"M67.6-154h666v666h-666z\"/></clipPath></defs><g clip-path=\"url(#SVGwQJ26ddR)\" transform=\"translate(-52 118.4)scale(.7688)\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#319400\" d=\"M0-154h333v666H0z\"/><path fill=\"#ffd600\" d=\"M333-154h666v333H333z\"/><path fill=\"#de2110\" d=\"M333 179h666v333H333z\"/></g></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bj1x1
